exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading {\n  margin-bottom: 20px;\n}\n\n.meeting-container {\n  margin-bottom: 10px;\n}\n\n.meeting-item {\n  margin-bottom: 7px;\n  border-bottom: 1px solid #eee;\n  padding: 5px 0;\n}\n\n.meeting-item.STOPPED {\n  opacity: 0.7;\n}\n\n.meeting-item.PLANNED {\n  color: green;\n}\n\n.meeting-item.LIVE {\n  color: red;\n}\n\n.meeting-item i.fa {\n  margin-left: 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/account-management/account-meeting-list/account-meeting-list.component.scss
// module id = ../../../../../src/app/components/account-management/account-meeting-list/account-meeting-list.component.scss
// module chunks = main